class ProductInfo extends HTMLElement {
  constructor() {
    super();

    // measurement quantity settings
    this.measureMent = {
      DEFAULT_MIN_VALUE: 0.5,
      DEFAULT_INITIAL_VALUE: 0.5,
      DEFAULT_STEP: 0.1,
      MAX_QUANTITY: 0,
      CURRENT_PRICE: 0,
      COMPARE_AT_PRICE: 0,
      SELECTOR_EXIST: false,
      wheels: {
        meterSlider: null,
        centimeterSlider: null,
      },
      selectedIndexPair: [0, 0],
    };

    // slider
    this.productImages = {
      slider: null,
      lightBox: null,
    };

    // quantity selector
    this.debouncePlusQuantity = this.debounce(
      this.handlePlusQuantity.bind(this),
      100,
    );
    this.debounceMinusQuantity = this.debounce(
      this.handleMinusQuantity.bind(this),
      100,
    );
    this.debounceHandleQuantityInput = this.debounce(
      this.handleQuantityInput.bind(this),
      100,
    );

    // measurement selector
    this.debounceHandlePlusMeasurement = this.debounce(
      this.handlePlusMeasureMent.bind(this),
      100,
    );
    this.debounceHandleMinusMeasurement = this.debounce(
      this.handleMinusMeasureMent.bind(this),
      100,
    );
    this.debounceHandleMeasurementUIInput = this.debounce(
      this.handleMeasurementUIInput.bind(this),
      100,
    );
    this.debounceHandleMeasurementSlidesChange = this.debounce(
      this.handleMeasurementSlidesChange.bind(this),
      100,
    );
    this.debounceHandleOPenMeasurementPopover = this.debounce(
      this.handleOpenMeasurementPopover.bind(this),
      100,
    );
    this.debounceHandleCloseMeasurementPopover = this.debounce(
      this.handleCloseMeasurementPopover.bind(this),
      100,
    );

    // add to cart
    this.debounceHandleAddToCart = this.debounce(
      this.handleAddToCart.bind(this),
      100,
    );

    // variant
    this.debounceHandleVariant = this.debounce(
      this.handleVariant.bind(this),
      100,
    );
    this.debounceHandleVariantOption = this.debounce(
      this.handleVariantOption.bind(this),
      100,
    );

    // info accordion
    this.debounceHandleOpenInfoAccordion = this.debounce(
      this.handleOpenInfoAccordion.bind(this),
      100,
    );
  }

  connectedCallback() {
    this.quantityType = this.getAttribute("data-quantity-type") || "normal";
    this.productHandle = this.getAttribute("data-product-handle");
    this.addToCartMode = this.getAttribute("data-add-to-cart-mode");
    this.sectionSettings = {
      vendor: this.getAttribute("data-show-vendor") === "true",
      sku: this.getAttribute("data-show-sku") === "true",
      quantity: this.getAttribute("data-show-quantity-selector") === "true",
      dynamicCheckout:
        this.getAttribute("data-show-dynamic-checkout") === "true",
      socialShare: this.getAttribute("data-show-social-sharing") === "true",
    };
    // init
    this.init();
    this.initImageSlider();
  }

  init() {
    this.domElements();
    this.bindListeners();
    //? LightBox
    this.gLightBox.length && this.initLightBox();

    // reset object measurement
    this.measureMent = {
      DEFAULT_MIN_VALUE: 0.5,
      DEFAULT_INITIAL_VALUE: 0.5,
      DEFAULT_STEP: 0.1,
      MAX_QUANTITY: 0,
      CURRENT_PRICE: 0,
      COMPARE_AT_PRICE: 0,
      SELECTOR_EXIST: this.quantityType === "CM",
      wheels: {
        meterSlider: null,
        centimeterSlider: null,
      },
      selectedIndexPair: [0, 0],
    };

    // check measurement input exists
    if (this.measureMent.SELECTOR_EXIST) {
      this.handleMeasurementQuantityInputExists();
      const currentUIValue = parseFloat(this.measureMentUIInput?.value || 0);
      if (currentUIValue < 0.5) {
        this.handleMeasurementInputValue(0.5);
      }
    }

      //? remove from url t
    this.handleRemoveTimestampQueryParam();
  }

  domElements() {
    this.productWrapperEl = this.querySelector(".product-info__wrapper");

    // image slider
    this.imageSlider = this.querySelector(".product-info__images__slider");
    this.sliderPagination = this.querySelector(".swiper__pagination");
    this.gLightBox = this.querySelectorAll(".glightbox");

    // quantity input
    this.quantityInput = this.querySelector(".product-add__input");
    this.buttonPlus = this.querySelector(
      ".product-add__qty-button.product-add__qty-button--plus",
    );
    this.buttonMinus = this.querySelector(
      ".product-add__qty-button.product-add__qty-button--minus",
    );

    // measurement input (unit)
    this.measureMentFormInput = this.querySelector(".measurement__form-input");
    this.measureMentUIInput = this.querySelector(
      ".product-add__measurement-input",
    );
    this.measureMentUIInputUnitLabel = this.querySelector(
      ".product-add__measurement-input__unit",
    );
    this.measureMentPlus = this.querySelector(
      ".product-add__qty-button.product-add__measurement-button--plus",
    );
    this.measureMentMinus = this.querySelector(
      ".product-add__qty-button.product-add__measurement-button--minus",
    );
    this.measureMentPriceLabel = this.querySelector(
      ".product-info__price.product-info__price--dynamic > span.current",
    );
    this.measureMentComparePriceLabel = this.querySelector(
      ".product-info__price.product-info__price--dynamic > span.compare-at-price",
    );

    // popover
    this.measureMentPopoverWrapper = this.querySelector(".measurement-popover");

    // measurement slider
    this.meterSliderEl = this.querySelector(
      ".measurement-popover-wheel__dial.measurement-popover-wheel__dial--meters",
    );
    this.centiMeterSliderEl = this.querySelector(
      ".measurement-popover-wheel__dial.measurement-popover-wheel__dial--centimeters",
    );

    // direct checkout
    this.directCheckoutInput = this.querySelector(
      "input.direct-checkout__quantity-input",
    );
    // add to cart button
    this.addToCartButton = this.querySelector(".product-add-to-cart");

    // cart error message
    this.cartErrorMessageWrapper = this.querySelector(".product-add__error");
    this.cartErrorMessageEl = this.querySelector(".product-add__error-message");

    // variant
    this.allVariantEl = this.querySelectorAll(".product-info__variant");

    // info accordions
    this.infoAccordions = this.querySelectorAll(".product-info__accordion");
  }

  bindListeners() {
    // click
    if (!this.clickHandler) {
      // quantity
      this.clickHandler = (e) => {
        if (e.target.closest(".product-add__qty-button--plus")) {
          this.debouncePlusQuantity(e);
          return;
        }
        if (e.target.closest(".product-add__qty-button--minus")) {
          this.debounceMinusQuantity(e);
          return;
        }

        // measurement input
        if (e.target.closest(".product-add__measurement-button--minus")) {
          const isMobile = this.handleIsMobile();
          isMobile
            ? this.debounceHandleOPenMeasurementPopover()
            : this.debounceHandleMinusMeasurement(e);
          return;
        }

        if (e.target.closest(".product-add__measurement-button--plus")) {
          const isMobile = this.handleIsMobile();
          isMobile
            ? this.debounceHandleOPenMeasurementPopover()
            : this.debounceHandlePlusMeasurement(e);
          return;
        }

        if (e.target.closest(".measurement-popover-overlay")) {
          this.debounceHandleCloseMeasurementPopover(e);
          return;
        }

        if (e.target.closest(".product-add-to-cart")) {
          this.debounceHandleAddToCart(e);
          return;
        }
        if (e.target.closest(".product-info__variant--trigger")) {
          this.debounceHandleVariant(e);
          return;
        }
        if (e.target.closest(".product-info__variant--option")) {
          this.debounceHandleVariantOption(e);
          return;
        }

        // info accordion
        if (e.target.closest(".product-info__accordion__header")) {
          this.debounceHandleOpenInfoAccordion(e);
          return;
        }
      };
    }
    this.removeEventListener("click", this.clickHandler);
    this.addEventListener("click", this.clickHandler);

    // quantity input
    if (!this.inputChangeHandler) {
      this.inputChangeHandler = (e) => {
        this.debounceHandleQuantityInput(e);
      };
    }
    this.quantityInput?.removeEventListener("blur", this.inputChangeHandler);
    this.quantityInput?.addEventListener("blur", this.inputChangeHandler);

    // measurement input
    if (!this.measureMentInputChangeHandler) {
      this.measureMentInputChangeHandler = (e) => {
        this.debounceHandleMeasurementUIInput(e);
      };
    }
    this.measureMentUIInput?.removeEventListener(
      "blur",
      this.measureMentInputChangeHandler,
    );
    this.measureMentUIInput?.addEventListener(
      "blur",
      this.measureMentInputChangeHandler,
    );

    // document
    if (!this.documentClickHandler) {
      this.documentClickHandler = (e) => {
        if (!e.target.closest(".product-info__variant")) {
          this.hideAllVariantDropDowns();
        }
        if (!e.target.closest(".product-info__accordions__wrapper")) {
          this.handleCloseInfoAccordions();
        }
      };
    }
    document.removeEventListener("click", this.documentClickHandler);
    document.addEventListener("click", this.documentClickHandler);

    //? remove when loaded 
    this?.classList?.remove("product-info--hidden");
  }

  debounce(fn, delay) {
    let timer;
    return function (...args) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

  initImageSlider() {
    this.productImages.slider = new Swiper(this.imageSlider, {
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        // el: this.sliderPagination,
        el: ".js-swiper-effect-fade-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-swiper-pagination-progress-button-next",
        prevEl: ".js-swiper-pagination-progress-button-prev",
      },
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: true,
      // },
      keyboard: {
        enabled: true,
      },
    });
  }

  initLightBox() {
    this.productImages.lightBox = GLightbox({
      selector: ".glightbox",
      zoomable: true,
      touchNavigation: true,
      loop: true,
      closeButton: true,
    });
  }

  /** handle remove timestamp query param from url after load */
  handleRemoveTimestampQueryParam() {
    // This removes the ?t=... parameter from the address bar after the page loads
    const url = new URL(window.location.href);
    if (url.searchParams.has("t")) {
      url.searchParams.delete("t");
      window.history.replaceState({}, "", url.pathname + url.search);
    }
  }

  /* add to cart start ( normal quantity input) */
  handlePlusQuantity() {
    this.quantityInput.value = parseInt(this.quantityInput.value) + 1;
    this.disableMinusButton();
    this.handleQuantityToDirectCheckout();
  }

  handleMinusQuantity() {
    const inputValue = parseInt(this.quantityInput.value);
    this.quantityInput.value =
      inputValue <= 1 ? 1 : parseInt(this.quantityInput.value) - 1;
    this.disableMinusButton();
    this.handleQuantityToDirectCheckout();
  }

  disableMinusButton() {
    const inputValue = parseInt(this.quantityInput.value);
    if (inputValue <= 1) {
      this.buttonMinus.disabled = true;
    } else {
      this.buttonMinus.disabled = false;
    }
  }

  handleQuantityToDirectCheckout() {
    if (!this.directCheckoutInput) {
      return;
    }
    this.directCheckoutInput.value = this.getCurrentQuantity();
  }

  handleQuantityInput() {
    if (this.quantityInput.value < 1) {
      this.quantityInput.value = 1;
    }
    this.handleQuantityToDirectCheckout();
  }

  handleAddToCart(e) {
    const buttonEl = e.target.closest(".product-add-to-cart");

    if (!buttonEl) {
      console.error("No button element found");
      return;
    }

    const variantId = buttonEl.getAttribute("data-variant-id");
    const inputType = buttonEl.getAttribute("data-input-type");
    this.addToCart(variantId, buttonEl, inputType);
  }

  showCartErrorMessage(message, inputType) {
    // if (inputType === "unit") {
    //   this.cartErrorMessageWrapper.classList.remove("hidden");
    //   this.cartErrorMessageEl.innerText = this.handleUnitErrorMessage(message);
    //   return;
    // }
    this.cartErrorMessageWrapper.classList.remove("hidden");
    this.cartErrorMessageEl.innerText = message;
  }

  handleUnitErrorMessage(message) {
    const numberMatch = message.match(/\d+/);
    if (!numberMatch) return message;

    const originalNumberStr = numberMatch[0];
    // Insert commas in the originalNumber string for thousands
    const originalNumber = parseInt(originalNumberStr, 10);
    const convertedNumber = originalNumber / 10; // 0.1
    // const convertedNumber = originalNumber / 2; // 0.5

    return message.replace(originalNumberStr, convertedNumber.toString());
  }

  hideCartErrorMessage() {
    this.cartErrorMessageWrapper.classList.add("hidden");
    this.cartErrorMessageEl.innerText = "";
  }

  addLoadingClass() {
    this.addToCartButton.classList.add("product-add-to-cart--loading");
  }

  removeLoadingClass() {
    this.addToCartButton.classList.remove("product-add-to-cart--loading");
  }

  getCurrentQuantity() {
    const isCM =
      this.getAttribute("data-quantity-type") === "CM" ||
      this.quantityType === "CM";
    if (isCM) {
      const rawValue = Number(this.measureMentFormInput.value || 0);
      const validatedValue = rawValue < 5 ? 5 : rawValue;
      // Sync the hidden input just in case
      if (this.measureMentFormInput) {
        this.measureMentFormInput.value = validatedValue;
      }
      return validatedValue;
    }
    return  Number(this.quantityInput.value) < 1 ? 1 : Number(this.quantityInput.value) || 1;
  }

  handleCartCountBubble(html) {
    const count = html
      .querySelector("cart-drawer")
      .getAttribute("data-cart-items-count");

    if (!count) {
      console.error("No cart count found");
      return;
    }

    const cartCountElements = document.querySelectorAll(
      "span.cart-item-count-header.cart-item-count-header--quantity",
    );

    // bubble
    const cartCountBubbles = document.querySelectorAll(
      "span.cart-item-count-header.cart-item-count-header--dot",
    );

    if (cartCountElements.length === 0 && cartCountBubbles.length === 0) {
      console.error("No cart count elements found");
      return;
    }

    if (cartCountElements.length) {
      cartCountElements.forEach((element) => {
        element.textContent = count;
      });
    }

    if (cartCountBubbles.length) {
      cartCountBubbles.forEach((element) => {
        if (Number.parseInt(count) > 0) {
          element.classList.remove("cart-item-count-header--dot-hidden");
        } else {
          element.classList.add("cart-item-count-header--dot-hidden");
        }
      });
    }
  }

  handleButtonTextChange(buttonEl, temporaryLabel = "Added", delay = 1000) {
    if (!buttonEl) {
      console.error("No button element found");
      return;
    }

    const labelEl = buttonEl.querySelector(".product-add__button-text");

    if (!labelEl) {
      console.error("No label element found");
      return;
    }

    if (buttonEl._resetTextTimer) {
      clearTimeout(buttonEl._resetTextTimer);
      buttonEl._resetTextTimer = null;
    }

    const oldLabel = labelEl.innerText;
    labelEl.innerHTML = temporaryLabel;

    buttonEl._resetTextTimer = setTimeout(() => {
      labelEl.innerHTML = oldLabel;
    }, delay);
  }

  handleUpdateCartDrawer(html) {
    const formBody = html.querySelector("form.cart-drawer__content--body");

    if (!formBody) {
      console.error("No form body found");
      return;
    }

    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && typeof cartDrawer.handleBodyReRender === "function") {
      cartDrawer.handleBodyReRender(formBody.innerHTML);
    }
  }

  handleShowCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && typeof cartDrawer.handleOpen === "function") {
      cartDrawer.handleOpen();
    }
  }

  handleCartUpdates(html, buttonEl, hasError) {
    // update cart count
    this.handleCartCountBubble(html);

    // update cart drawer
    this.handleUpdateCartDrawer(html);

    if (hasError) {
      return;
    }

    switch (this.addToCartMode) {
      case "message":
        this.handleButtonTextChange(buttonEl);
        break;
      case "drawer":
        this.handleShowCartDrawer();
        break;
      default:
        location.href = "/cart";
        break;
    }
  }

  async addToCart(variantId, buttonEl, inputType) {
    let hasError = false;
    try {
      this.addLoadingClass();
      let finalQuantity = this.getCurrentQuantity();

      if (this.quantityType === "CM" && finalQuantity < 5) {
        finalQuantity = 5;
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: finalQuantity,
            },
          ],
          sections: "cart-drawer-new",
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data?.description || data?.message);

      if (!data.sections["cart-drawer-new"]) {
        throw new Error("No cart-drawer-new section found in API response");
      }

      this.hideCartErrorMessage();
    } catch (error) {
      hasError = true;
      this.showCartErrorMessage(error.message, inputType);
      console.error("Error adding to cart:", error);
    } finally {
      this.removeLoadingClass();
      const cart = await this.getCart();
      this.handleCartUpdates(
        new DOMParser().parseFromString(cart["cart-drawer-new"], "text/html"),
        buttonEl,
        hasError,
      );
    }
  }

  async getCart() {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart?sections=cart-drawer-new`,
      );
      const data = await response.json();
      if (!response.ok) throw new Error(data?.description || data?.message);
      return data;
    } catch (error) {
      console.error("Error getting cart:", error);
    }
  }
  /* add to cart end */

  /* variant start */
  handleVariant(e) {
    const triggerEl = e.target.closest(".product-info__variant--trigger");

    if (!triggerEl) {
      console.error("No trigger element found");
      return;
    }
    const parentEl = triggerEl.closest(".product-info__variant");

    if (!parentEl) {
      console.error("No parent element found");
      return;
    }

    const listOptionEl = parentEl.querySelector(
      ".product-info__variant--options",
    );

    if (triggerEl.classList.contains("active")) {
      triggerEl.classList.remove("active");
      listOptionEl.classList.remove("open");
    } else {
      //? closed all other filter options
      this.hideAllVariantDropDowns();
      //? show current filter
      triggerEl.classList.add("active");
      listOptionEl.classList.add("open");
    }
  }

  handleVariantOption(e) {
    const optionEl = e.target.closest(".product-info__variant--option");

    if (!optionEl) {
      console.error("No option element found");
      return;
    }

    const variantId = optionEl.getAttribute("data-variant-id");
    const imageId = optionEl.getAttribute("data-image-id");
    this.handleVariantState(optionEl);
    this.handleUpdateVariantIdToUrl(variantId);
    this.handleUpdateVariantImage(imageId);
    this.getProduct();
  }

  hideAllVariantDropDowns() {
    this.allVariantEl.forEach((el) => {
      el.querySelector(".product-info__variant--trigger").classList.remove(
        "active",
      );
      el.querySelector(".product-info__variant--options").classList.remove(
        "open",
      );
    });
  }

  handleVariantState(optionEl) {
    const optionName = optionEl.getAttribute("data-option-name");
    if (!optionName) {
      console.error("No option name found");
      return;
    }
    const allOptions = this.querySelectorAll(
      `.product-info__variant--option-${optionName}`,
    );
    const variantEl = this.querySelector(
      `.product-info__variant.product-info__variant--${optionName}`,
    );
    const dropdownLabel = variantEl.querySelector(
      ".product-info__variant--selected-variant",
    );

    if (!allOptions && !variantEl && !dropdownLabel) {
      console.error("No elements found");
      return;
    }
    allOptions.forEach((el) => {
      el.classList.remove("active");
    });
    optionEl.classList.add("active");
    dropdownLabel.innerText = optionEl.innerText;
  }

  handleUpdateVariantIdToUrl(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    history.replaceState({}, "", url);
  }

  handleUpdateVariantImage(imageId) {
    if (!imageId) {
      return;
    }

    const slides = this.imageSlider.querySelectorAll(
      ".swiper-slide.product-info__image",
    );

    let indexToGo = -1;

    slides.forEach((slide, i) => {
      if (slide.getAttribute("data-image-id") === imageId) {
        indexToGo = i;
      }
    });

    if (indexToGo !== -1 && this.productImages.slider) {
      this.productImages.slider.slideTo(indexToGo, 300);
    }
  }

  handleRerender(html) {
    const selectors = [
      "vendor",
      "sku",
      "price",
      "quantity",
      "dynamicCheckout",
      "variants",
      "socialShare",
    ];

    selectors.forEach((selector) => {
      const newElement = html.querySelector(`#product-${selector}`);
      const currentElement = this.querySelector(`#product-${selector}`);

      if (!newElement && currentElement) {
        currentElement.classList.add("hidden");
        return;
      }

      if (!currentElement || !newElement) {
        return;
      }

      // Update the inner HTML of the current element with the new element's content
      currentElement.innerHTML = newElement.innerHTML;

      // Handle visibility based on section settings
      switch (selector) {
        case "vendor":
          currentElement.classList.toggle(
            "hidden",
            !this.sectionSettings.vendor,
          );
          break;
        case "sku":
          currentElement.classList.toggle("hidden", !this.sectionSettings.sku);
          break;
        case "quantity":
          currentElement.classList.toggle(
            "hidden",
            !this.sectionSettings.quantity,
          );
          break;
        case "dynamicCheckout":
          currentElement.classList.toggle(
            "hidden",
            !this.sectionSettings.dynamicCheckout,
          );
          break;
        case "socialShare":
          currentElement.classList.toggle(
            "hidden",
            !this.sectionSettings.socialShare,
          );
          break;
        default:
          break;
      }
    });

    const newType = html
      .querySelector("product-info")
      ?.getAttribute("data-quantity-type");
    if (newType) {
      const checkType = this.quantityType === newType;
      this.quantityType = checkType ? this.quantityType : newType;
      this.setAttribute("data-quantity-type", newType);
    }

    this.dispatchEvent(
      new CustomEvent("variant:contentUpdated", { bubbles: true }),
    );

    this.init();
  }

  getActiveVariantOptions() {
    const allActiveOptions = this.querySelectorAll(
      ".product-info__variant--option.active",
    );

    if (!allActiveOptions && allActiveOptions.length) {
      console.error("No active options found");
      return;
    }
    return Array.from(allActiveOptions)
      .map((el) => el.getAttribute("data-option-id"))
      .join(",");
  }

  async getProduct() {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${
          this.productHandle
        }?section_id=product-info&option_values=${this.getActiveVariantOptions()}&t=${Date.now().toString()}`,
      );
      const html = await response.text();

      if (!response.ok) throw new Error(html);

      const htmlDoc = new DOMParser().parseFromString(html, "text/html");
      this.handleRerender(htmlDoc);
    } catch (error) {
      console.error("Error fetching product:", error);
    }
  }
  /** variant end */

  /** measurement base quantity calculation start */
  handleMeasurementQuantityInputExists() {
    // Ensure DOM elements are refreshed
    this.domElements();

    if (!this.measureMentFormInput || !this.measureMentUIInput) {
      console.error(
        "Scalability Error: Quantity Type is CM but inputs are missing from Liquid!",
      );
      return;
    }

    this.measureMent.DEFAULT_STEP = this.measureMentUIInput.getAttribute("step")
      ? parseFloat(this.measureMentUIInput.getAttribute("step"))
      : this.measureMent.DEFAULT_STEP;
    this.measureMent.MAX_QUANTITY = this.measureMentUIInput.getAttribute("max")
      ? parseInt(this.measureMentUIInput.getAttribute("max"), 10)
      : this.measureMent.MAX_QUANTITY;
    this.measureMent.CURRENT_PRICE = this.measureMentUIInput.getAttribute(
      "price",
    )
      ? parseFloat(this.measureMentUIInput.getAttribute("price"))
      : this.measureMent.CURRENT_PRICE;

    this.measureMent.COMPARE_AT_PRICE = this.measureMentUIInput.getAttribute(
      "compare-at-price",
    )
      ? parseFloat(this.measureMentUIInput.getAttribute("compare-at-price"))
      : this.measureMent.COMPARE_AT_PRICE;
    // reset
    this.handleResetMeasurementQuantityInput();

    // disable buttons
    this.handleDisableMinusMeasureMentButton();

    // init measurement sliders
    if (!this.measureMent.wheels.meterSlider) {
      this.handleInitMeasurementMeterSlider();
      this.handleInitMeasurementCentimeterSlider();
    }
  }

  handleResetMeasurementQuantityInput() {
    this.measureMentUIInput.value = this.measureMent.DEFAULT_INITIAL_VALUE;
    this.measureMentFormInput.value = 5;
    this.handleMeasurementQuantityInputLabelValue(
      this.measureMent.DEFAULT_INITIAL_VALUE,
    );

    // UPDATE DIRECT CHECKOUT
    this.handleQuantityToDirectCheckout();
  }

  handleMeasurementQuantityInputLabelValue(value) {
    if (!this.measureMentUIInputUnitLabel) {
      console.error("label not found");
      return;
    }
    this.measureMentUIInputUnitLabel.textContent =
      this.measureMentUIInputUnitLabel.textContent.replace(/[\d.]+/, value);
  }

  handleDisableMinusMeasureMentButton() {
    const currentValue = parseFloat(this.measureMentUIInput.value);
    if (!this.measureMentMinus) {
      console.error("minus button not found");
      return;
    }
    this.measureMentMinus.disabled =
      currentValue <= this.measureMent.DEFAULT_MIN_VALUE;
  }

  handlePlusMeasureMent() {
    const currentValue = parseFloat(this.measureMentUIInput.value);
    const newValue = this.roundTheValue(
      currentValue + this.measureMent.DEFAULT_STEP,
    );
    this.handleMeasurementInputValue(newValue);
  }

  handleMinusMeasureMent() {
    const currentValue = parseFloat(this.measureMentUIInput.value);
    let newValue = this.roundTheValue(
      currentValue - this.measureMent.DEFAULT_STEP,
    );
    if (newValue < this.measureMent.DEFAULT_MIN_VALUE) {
      newValue = this.measureMent.DEFAULT_MIN_VALUE;
    }
    this.handleMeasurementInputValue(newValue);
  }

  handleMeasurementUIInput() {
    let currentValue = parseFloat(this.measureMentUIInput.value);
    if (
      isNaN(currentValue) ||
      currentValue < this.measureMent.DEFAULT_MIN_VALUE
    ) {
      currentValue = this.measureMent.DEFAULT_MIN_VALUE;
    }
    currentValue = this.roundTheValue(currentValue);
    this.handleMeasurementInputValue(currentValue);
  }

  handleMeasurementInputValue(value) {
    this.measureMentUIInput.value = value;
    this.handleMeasurementQuantityInputLabelValue(value);
    const quantity = Math.round(value / this.measureMent.DEFAULT_STEP);
    this.handleMeasurementFormInputValue(quantity);
    this.handleDisableMinusMeasureMentButton();
  }

  handleMeasurementFormInputValue(quantity) {
    const safeQuantity = quantity < 5 ? 5 : quantity;
    this.measureMentFormInput.value = safeQuantity;

    // update direct checkout
    this.handleQuantityToDirectCheckout();

    //? Update price
    if (safeQuantity > 0) this.handlePriceLabel(safeQuantity);
  }

  handlePriceLabel(quantity) {
    if (!this.measureMentPriceLabel) {
      console.error("Price label not found");
      return;
    }

    const exchangeRate = window?.Shopify?.currency?.rate;
    const country = window?.Shopify?.country;
    const currencyActive = window?.Shopify?.currency?.active;
    const activeLang = window?.Shopify?.locale;
    if (!exchangeRate || !country || !currencyActive || !activeLang) {
      console.error("Currency data not found");
      return;
    }
    const price = quantity * this.measureMent.CURRENT_PRICE * exchangeRate;
    this.measureMentPriceLabel.textContent = new Intl.NumberFormat(
      `${country}-${activeLang}`,
      {
        style: "currency",
        currency: currencyActive,
      },
    ).format(price);

    if (this.measureMentComparePriceLabel) {
      const compareAtPrice =
        quantity * this.measureMent.COMPARE_AT_PRICE * exchangeRate;
      this.measureMentComparePriceLabel.textContent = new Intl.NumberFormat(
        `${country}-${activeLang}`,
        {
          style: "currency",
          currency: currencyActive,
        },
      ).format(compareAtPrice);
    }
  }
  // 0.5
  // roundTheValue(value) {
  //   return Math.round(value * 2) / 2;
  // }
  // 0.1
  roundTheValue(value) {
    return Math.round(value * 10) / 10;
  }

  handleInitMeasurementMeterSlider() {
    this.measureMent.wheels.meterSlider = new Swiper(this.meterSliderEl, {
      direction: "vertical",
      slidesPerView: 4,
      centeredSlides: true,
      loop: false,
      mousewheel: true,
      slideToClickedSlide: true,
    });

    this.measureMent.wheels.meterSlider.on(
      "slideChange",
      this.debounceHandleMeasurementSlidesChange,
    );
  }

  handleInitMeasurementCentimeterSlider() {
    this.measureMent.wheels.centimeterSlider = new Swiper(
      this.centiMeterSliderEl,
      {
        direction: "vertical",
        slidesPerView: 4,
        centeredSlides: true,
        loop: false,
        mousewheel: true,
        slideToClickedSlide: true,
      },
    );

    this.measureMent.wheels.centimeterSlider.on(
      "slideChange",
      this.debounceHandleMeasurementSlidesChange,
    );
  }

  // new (slide hide 0 to 0.4)
  getLowCentimeterSlides() {
    if (!this.centiMeterSliderEl) return [];
    const slides = Array.from(
      this.centiMeterSliderEl.querySelectorAll(".swiper-slide"),
    );

    return slides.filter((slide) => {
      const v = parseFloat(slide.getAttribute("data-value") || "0");
      return v >= 0 && v < 0.5; // 0.0 to 0.4
    });
  }

  handleMeasurementSlidesChange() {
    const meterActiveSlide =
      this.measureMent.wheels.meterSlider.slides[
        this.measureMent.wheels.meterSlider.activeIndex
      ];
    const centimeterActiveSlide =
      this.measureMent.wheels.centimeterSlider.slides[
        this.measureMent.wheels.centimeterSlider.activeIndex
      ];

    if (!meterActiveSlide || !centimeterActiveSlide) return;

    const meterActiveSlideValue = parseFloat(
      meterActiveSlide.getAttribute("data-value") || 0,
    );
    let centimeterActiveSlideValue = parseFloat(
      centimeterActiveSlide.getAttribute("data-value") || 0,
    );

    /**
     * extra logic
     */
    // find 0–0.4 cm slides dynamically from existing markup
    const cmLowSlides = this.getLowCentimeterSlides();

    if (meterActiveSlideValue === 0) {
      // hide 0–0.4 cm slides visually
      cmLowSlides.forEach((slide) => {
        slide.style.visibility = "hidden";
        slide.style.pointerEvents = "none"; // prevent clicks on hidden slides
        slide?.classList.add("hide-slide");
      });

      // force to 0.5 if current cm is in hidden range (0–0.4)
      if (centimeterActiveSlideValue < 0.5) {
        const slides = Array.from(
          this.measureMent.wheels.centimeterSlider.slides,
        );
        const newIndex = slides.findIndex(
          (s) => parseFloat(s.getAttribute("data-value") || "0") === 0.5,
        );
        if (newIndex !== -1) {
          this.measureMent.wheels.centimeterSlider.slideTo(newIndex, 0);
          const newSlide =
            this.measureMent.wheels.centimeterSlider.slides[newIndex];
          centimeterActiveSlideValue = parseFloat(
            newSlide.getAttribute("data-value") || "0.5",
          );
        } else {
          // fallback if for some reason 0.5 not found
          centimeterActiveSlideValue = 0.5;
        }
      }
    } else {
      // meter >= 1 → show 0–0.4 cm slides again
      cmLowSlides.forEach((slide) => {
        slide.style.visibility = "visible";
        slide.style.pointerEvents = "auto"; // prevent clicks on hidden slides
        slide?.classList.remove("hide-slide");
      });
    }

    /**
     * extra logic end
     */

    let total = meterActiveSlideValue + centimeterActiveSlideValue;

    if (total < this.measureMent.DEFAULT_MIN_VALUE) {
      total = this.measureMent.DEFAULT_MIN_VALUE;

      // Visually snap the centimeter slider to 0.5 index
      if (this.measureMent.wheels.centimeterSlider) {
        const slides = Array.from(
          this.measureMent.wheels.centimeterSlider.slides,
        );
        const targetIndex = slides.findIndex(
          (s) => parseFloat(s.getAttribute("data-value")) === 0.5,
        );

        if (targetIndex !== -1) {
          this.measureMent.wheels.centimeterSlider.slideTo(targetIndex, 300);
        }
      }
    }

    this.handleMeasurementInputValue(total);
  }

  syncSelectedIndexPairFromInput() {
    if (!this.measureMentFormInput) return;

    const quantity = Number(this.measureMentFormInput.value);

    const step = this.measureMent.DEFAULT_STEP || 0.5;
    const totalMeters = quantity * step;
    const metersIndex = Math.floor(totalMeters);
    const centimetersValue = totalMeters - metersIndex;
    const centimeterStep = this.measureMent.DEFAULT_STEP || 0.5;
    const centimetersIndex = Math.round(centimetersValue / centimeterStep);

    this.measureMent.selectedIndexPair = [metersIndex, centimetersIndex];
  }

  handleSyncSlider() {
    this.syncSelectedIndexPairFromInput();
    this.measureMent.wheels.meterSlider.slideTo(
      this.measureMent.selectedIndexPair[0],
      300,
    );
    this.measureMent.wheels.centimeterSlider.slideTo(
      this.measureMent.selectedIndexPair[1],
      300,
    );
  }

  handleOpenMeasurementPopover() {
    if (!this.handleIsMobile()) return;

    this.handleSyncSlider();

    this.measureMentPopoverWrapper.classList.remove(
      "measurement-popover--closed",
    );
    this.measureMentPopoverWrapper.classList.add("measurement-popover--open");

    // scroll prevent
    document.body.style.overflow = "hidden";
  }

  handleCloseMeasurementPopover() {
    this.measureMentPopoverWrapper.classList.remove(
      "measurement-popover--open",
    );
    this.measureMentPopoverWrapper.classList.add("measurement-popover--closed");

    // scroll allow
    document.body.style.overflow = "auto";
  }

  handleIsMobile() {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  /** measurement unit base quantity calculation end */

  /** info accordion start */
  handleOpenInfoAccordion(e) {
    const headerEl = e.target.closest(".product-info__accordion__header");
    const contentEl = headerEl.nextElementSibling;

    if (!headerEl || !contentEl) {
      console.error("Header or content element not found");
      return;
    }

    if (
      headerEl.classList.contains("open") &&
      !headerEl.classList.contains("product-info__accordion__header--first")
    ) {
      headerEl.classList.remove("open");
      contentEl.classList.remove("open");
    } else {
      this.handleCloseInfoAccordions(true);
      headerEl.classList.add("open");
      contentEl.classList.add("open");
    }
  }

  handleCloseInfoAccordions(firstClose = false) {
    if (!this.infoAccordions || this.infoAccordions.length === 0) {
      console.error("No info accordions found");
      return;
    }

    if (firstClose) {
      this.infoAccordions.forEach((el) => {
        el.querySelector(".product-info__accordion__header").classList.remove(
          "open",
        );
        el.querySelector(".product-info__accordion__content").classList.remove(
          "open",
        );
      });
    } else {
      this.infoAccordions.forEach((el) => {
        if (
          el
            ?.querySelector(".product-info__accordion__header")
            .classList?.contains("product-info__accordion__header--first")
        ) {
          el?.querySelector(".product-info__accordion__header").classList.add(
            "open",
          );
        } else {
          el?.querySelector(
            ".product-info__accordion__header",
          ).classList.remove("open");
        }
        if (
          el
            ?.querySelector(".product-info__accordion__content")
            .classList?.contains("product-info__accordion__content--first")
        ) {
          el?.querySelector(".product-info__accordion__content").classList.add(
            "open",
          );
        } else {
          el?.querySelector(
            ".product-info__accordion__content",
          ).classList.remove("open");
        }
      });
    }
  }
  /** info accordion end */

  disconnectedCallback() {
    if (this.productImages.slider) {
      this.productImages.slider.destroy();
      this.productImages.slider = null;
    }

    if (this.productImages.lightBox) {
      this.productImages.lightBox.destroy();
      this.productImages.lightBox = null;
    }

    this.removeEventListener("click", this.clickHandler);
    this.quantityInput?.removeEventListener("blur", this.inputChangeHandler);
    this.measureMentUIInput?.removeEventListener(
      "blur",
      this.measureMentInputChangeHandler,
    );
    document.removeEventListener("click", this.documentClickHandler);
  }
}

customElements.define("product-info", ProductInfo);
